import { render, staticRenderFns } from "./couponDetails.vue?vue&type=template&id=5ff838e0&scoped=true&"
import script from "./couponDetails.vue?vue&type=script&lang=js&"
export * from "./couponDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff838e0",
  null
  
)

component.options.__file = "couponDetails.vue"
export default component.exports